import React from "react";
import { MultiUsersIcon } from "../../SvgIcons/MultiUsersIcon";
import { CopyIcon } from "../../SvgIcons/CopyIcon";
import { toast } from "react-toastify";
import { getErrorMessage } from "../../../../utilities/errors";
import { RecordingIcon } from "../../SvgIcons/RecordingIcon";
import { ChatIcon } from "../../SvgIcons/ChatIcon";
import { BehaviorSubject } from "rxjs";
import { ScreenResizeIcon } from "../../SvgIcons/ScreenResizeIcon";

interface VideoChatHeaderPropsType {
  roomId?: string;
  handleRecordClick?: () => void;
  isRecording?: boolean;
  isNewMessageReceived?: boolean;
  messageOpen: boolean;
  setMessageOpen: (open: boolean) => void;
  isNewMessageReceivedSubject: BehaviorSubject<boolean>;
  isMobileView?: boolean;
  setShowParticipantsGrid: (showParticipantGrid: boolean) => void;
  showParticipantGrid: boolean;
  isSharingScreen: boolean;
}

const VideoChatHeader: React.FC<VideoChatHeaderPropsType> = ({
  roomId,
  handleRecordClick,
  messageOpen = false,
  setMessageOpen,
  isNewMessageReceivedSubject,
  isNewMessageReceived,
  isMobileView = false,
  setShowParticipantsGrid,
  showParticipantGrid,
  isSharingScreen = false,
}) => {
  /**
   * React.js reference Hooks
   **/

  /**
   * @method getFormattedRoomID() - Method to get the room Id sliced and formatted
   * @param roomID - string
   **/
  const getFormattedRoomID = (roomID: string) => {
    if (!roomID || roomID === "") return "N/A";

    // get the 1/3 part of the roomId just to show case the front characters
    return roomID?.substring(0, Math.ceil(roomID?.length / 3));
  };

  /**
   * @method copyIdToClipBoard() - Method used to copy the Id to the clipboard
   **/
  const copyIdToClipBoard = async () => {
    if (!roomId || roomId === "") {
      throw new Error("Room Id not found");
    }

    try {
      const roomUrl = `${window?.location?.origin}/lobby/${roomId}`;
      await navigator?.clipboard?.writeText(roomUrl);
      toast.success("Room Id copied to clipboard");
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
    }
  };
  return (
    <>
      <div className="px-8 pt-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[1rem]">
            <button className="bg-[#8D8D8D] w-10 py-[0.65rem] flex justify-center items-center rounded-xl">
              <MultiUsersIcon size={16} strokeColor="#fff" />
            </button>

            <button
              onClick={() => {
                isNewMessageReceivedSubject.next(messageOpen ? false : true);
                setMessageOpen(!messageOpen);
              }}
              className="bg-[#8D8D8D] w-10 py-[0.625rem] flex justify-center items-center rounded-xl relative"
            >
              <ChatIcon />
              {isNewMessageReceived && !messageOpen && (
                <p className="m-0 bg-[#9810FA] h-6 w-6 rounded-full text-white absolute top-[-0.5rem] end-[-0.5rem]">
                  {0}
                </p>
              )}
            </button>

            {roomId && (
              <div className="bg-[#8D8D8D] py-[0.5rem] px-4 rounded-xl flex gap-10 items-center">
                <p className="m-0 text-white">{getFormattedRoomID(roomId)}</p>

                <button onClick={copyIdToClipBoard}>
                  <CopyIcon size={16} />
                </button>
              </div>
            )}
          </div>

          <div className="flex gap-[1rem]">
            <button
              onClick={handleRecordClick}
              className="px-[0.875rem] rounded-xl flex items-center py-[0.5rem] gap-[0.5rem] bg-[#7E57C2]"
            >
              <span>
                <RecordingIcon />
              </span>
              {
                !isMobileView && (
                  <span>Start Recording</span>

                )
              }
            </button>

            {isSharingScreen && (
              <button
                onClick={() => {
                  setShowParticipantsGrid(!showParticipantGrid);
                }}
                className="flex justify-center items-center p-0 rounded-full"
              >
                <ScreenResizeIcon size={34} />
              </button>
            )}
          </div>
        </div>
      </div>

      {/* {(!isMobileView || !messagesOpen) && (
        <div
          className="position-absolute top-0 start-0 p-4 w-100 d-flex justify-content-between align-items-center"
          style={{ zIndex: 30 }}
        >
          <div className="flex justify-center align-middle items-center gap-3">
            <div
              className="hover:bg-gray-500 bg-white cursor-pointer text-dark rounded-full p-6 d-flex align-items-center justify-content-center"
              style={{ width: "40px", height: "40px" }}
              onClick={handleHangUpClick}
            >
              <FontAwesomeIcon icon={faArrowLeft} size="lg" />
            </div>

            <div className="tooltip-container">
              <div
                className="hover:bg-gray-500 bg-white cursor-pointer text-dark rounded-full p-6 d-flex align-items-center justify-content-center"
                style={{ width: "40px", height: "40px" }}
                onClick={handleRecordClick}
              >
                <RecordButton isRecording={false} />
              </div>

              {showRecordTooltip && (
                <div className="custom-tooltip">
                  Recording is unavailable in the beta version
                </div>
              )}
            </div>
          </div>

          {lobbyState?.relatedChatConversationId &&
            Object.keys(remoteFeeds).length === 0 &&
            lobbyState.isPublisher &&
            isCalling && (
              <div
                style={{
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 40,
                }}
                className="bg-[#2e2e2e] text-white rounded-full px-3 py-2 d-flex align-items-center gap-2"
              >
                <span aria-hidden>📞</span>
                <span>Calling…</span>
              </div>
            )}

          <button
            className="rounded-full bg-[#7e57c2] text-white p-6 d-flex align-items-center justify-content-center position-relative"
            style={{ width: "40px", height: "40px" }}
            onClick={() => {
              isNewMessageReceivedSubject.next(messagesOpen ? false : true);
              setMessagesOpen((p) => !p);
            }}
          >
            {isNewMessageReceived && !messagesOpen && (
              <span
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  borderRadius: "50%",
                  background: "red",
                  width: "10px",
                  height: "10px",
                }}
              ></span>
            )}
          </button>
        </div>
      )} */}
    </>
  );
};

export default VideoChatHeader;
